export default {"src":"/_next/static/media/build-process.923eca82.svg","height":420,"width":380};